import { render, staticRenderFns } from "./DashboardV2.vue?vue&type=template&id=3fcfbee0&scoped=true&"
import script from "./DashboardV2.vue?vue&type=script&lang=js&"
export * from "./DashboardV2.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV2.vue?vue&type=style&index=0&id=3fcfbee0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcfbee0",
  null
  
)

component.options.__file = "DashboardV2.vue"
export default component.exports